import React from 'react';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import CloseIcon from '@material-ui/icons/Close';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { postImageFolder } from '../redux/actions/imageActions';
import MyButton from './MyButton';

const styles = theme => ({
    ...theme,
    closeButton: {
        position: 'absolute',
        left: '91%',
        top: '6%'
    },
  })

class AddImageFolder extends React.Component {
  state = {
    open: false,
    name: '',
    errors: {}
  };

  componentWillReceiveProps(nextProps){
    if(nextProps.UI.errors) {
        this.setState({
            errors: nextProps.UI.errors
        });
    };
    if(!nextProps.UI.errors && !nextProps.UI.loading) {
        this.setState({
            name: '',
            open: false,
            errors: {}
        })
    }
}

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
    };
    handleSubmit = (event) => {
        event.preventDefault();
        this.props.postImageFolder({
            name: this.state.name,
        });
    }

  render() {
    const { classes, UI: { loading } } = this.props;
    const { errors } = this.state;
    return (
      <div>
        <button className="btn btn-primary-outline" onClick={this.handleClickOpen}>
            Thêm mới
        </button>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          fullWidth
          maxWidth='sm'
          aria-labelledby="form-dialog-title"
        >
            <MyButton tip="Close" onClick={this.handleClose} tipClassName={classes.closeButton}>
                <CloseIcon />
            </MyButton>
          <DialogTitle id="form-dialog-title">Thêm mới danh mục</DialogTitle>
          <form onSubmit={this.handleSubmit}>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              name="name"
              label="Folder name"
              type="text"
              error={errors.name ? true : false}
                        helperText={errors.name}
              fullWidth
              onChange={this.handleChange}
            />
          </DialogContent>
          <DialogActions>
            <button 
                type="submit"
                disabled={loading}
                className="btn btn-primary"
            >
              {loading ? (
                        <><i className="fas fa-spinner fa-pulse" /> Đang cập nhật</>
              ) :
                'Thêm mới'
              }
            </button>
          </DialogActions>
          </form>
        </Dialog>
      </div>
    );
  }
}

AddImageFolder.propTypes = {
    classes: PropTypes.object.isRequired,
    postImageFolder: PropTypes.func.isRequired,
  }
  
  const mapStateToProps = state => ({
    UI: state.UI
  })
  
export default connect(mapStateToProps, { postImageFolder })(withStyles(styles)(AddImageFolder));